Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.DATE_TIME = (function () {

    function DATE_TIME (field, entity) {

        Greenmile.PanelBuilder.Fields.ComplexField.apply(this, arguments);

    };

    return DATE_TIME;

}());